import { useAuth0 } from "@auth0/auth0-react";
import { Toast } from "components";
import Loader from "components/loader/Loader";
import { AppLayout } from "layout";
import { I18nProvider } from "locales";
import { LockLoader } from "pages/lockLoader";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import {
  Redirect,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
// Components
import { HomeRouters, PrivateRoute } from "Router";
import { getDateFormat } from "helper/dateFormat";

export const DateFormetContext = React.createContext();

const App = () => {

  const { isRTL, lang } = useSelector((state) => state?.locales);
  const { isLoading } = useAuth0();
  const isDonationLayout = useSelector(state => state?.CommonStates?.isDonationLayout); 

  const dateFormat = getDateFormat();
  const formatedDate = dateFormat;

  if (isLoading)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loader />
      </div>
    );
  return (
    <>
      <Helmet>
        <html lang={lang} dir={isRTL ? "rtl" : "ltr"} />
      </Helmet>
      <Router>
        <LockLoader />
        <Toast />
        <I18nProvider>
          <DateFormetContext.Provider value={formatedDate}>
            <AppLayout isDonationLayout={isDonationLayout}> 
              <Switch>
                <PrivateRoute path="/">
                  <HomeRouters />
                </PrivateRoute>
                <Redirect path="*" to="/" />
              </Switch>
            </AppLayout>
          </DateFormetContext.Provider>
        </I18nProvider>
      </Router>
    </>
  );
};
export default App; 
 